import script from "./CardOption.vue?vue&type=script&setup=true&lang=js"
export * from "./CardOption.vue?vue&type=script&setup=true&lang=js"

import "./CardOption.vue?vue&type=style&index=0&id=0390cf23&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0390cf23"]])

export default __exports__